import { convertRequestParams } from '@redux/crudCreator/dataProvider';
import { createApi, retry } from '@reduxjs/toolkit/query/react';
import { getAllApi } from 'api/crud';

// Define a service using a base URL and expected endpoints
export const referencesApi = createApi({
  reducerPath: 'referencesApi',
  tagTypes: ['reference'],
  baseQuery: retry(
    async (payload) => {
      try {
        const data = await getAllApi(
          payload.model,
          convertRequestParams('GET_ALL', payload.filters),
        );
        return data;
      } catch (error) {
        return { error: error || {} };
      }
    },
    { maxRetries: 0 },
  ),
  endpoints: (builder) => ({
    getReference: builder.query({
      query: (payload) => payload,
    }),
  }),
});

export const { useGetReferenceQuery } = referencesApi;
